import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Try to import local config (will be git-ignored)
let localConfig;
try {
  localConfig = require('./firebase.local.js');
} catch {
  // No local config, that's fine
}

// Staging config
const stagingConfig = {
  apiKey: "AIzaSyBUh_ZwbAf08UyIWxToXqPAkNlWnxldxJM",
  authDomain: "harken-tech-staging.firebaseapp.com",
  projectId: "harken-tech-staging",
  storageBucket: "harken-tech-staging.firebasestorage.app",
  messagingSenderId: "1062755224974",
  appId: "1:1062755224974:web:d9814fcb80e7b20cbfa8df"
};

// Production config 
const productionConfig = {
  apiKey: "AIzaSyDsPQbdIzmNp4a5TloMj19HiQAm8KYs8cE",
  authDomain: "harken-tech-prod.firebaseapp.com",
  projectId: "harken-tech-prod",
  storageBucket: "harken-tech-prod.firebasestorage.app",
  messagingSenderId: "586512196858",
  appId: "1:586512196858:web:4f1e80659ac4cc3a559543",
  measurementId: "G-D07BYTDS30"
}

// Determine which config to use
const getFirebaseConfig = () => {

  // 1. Use environment variable to distinguish staging vs prod builds
  if (process.env.REACT_APP_FIREBASE_ENV === 'production') {
    console.log('Using Production Firebase config');
    return productionConfig;
  }

  // 2. Use environment variable to distinguish staging vs prod builds
  if (process.env.REACT_APP_FIREBASE_ENV === 'staging') {
    console.log('Using Staging Firebase config');
    return stagingConfig;
  }

  // 3. Local override takes highest priority (for npm start)
  if (localConfig) {
    console.log('Using local firebase.local.js config');
    return localConfig.default || localConfig;
  }

  // 4. Fallback: If no config is found, log and crash
  const errorMessage =
    'FATAL: No Firebase configuration found. ' +
    'Set REACT_APP_FIREBASE_ENV (to "staging" or "production") ' +
    'or create a firebase.local.js file for local development.';

  console.error(errorMessage);
  throw new Error(errorMessage);
};

const firebaseConfig = getFirebaseConfig();

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export default app;

